module.exports = __webpack_public_path__ + "img/29.4bb935b5.png";